<template>
  <div class="columns is-mobile is-centered has-background-primary p-2">
    <h1 class="title is-4 has-text-white">TEMPLATE</h1>
  </div>
  <!-- SEZIONE GESTIONE TEMPLATE QUESTIONARI -->
  <div class="box mt-4" v-if="credenzialiUtente && (credenzialiUtente.autorizzazione == 'amministratore' || credenzialiUtente.autorizzazione == 'sviluppatore')">
    <h2 class="title is-5 has-text-primary">
      <span class="icon"><i class="fas fa-file-invoice"></i></span>
      Template Questionari Area Clienti
    </h2>
    <hr>
    
    <div v-if="!impostazioniGenerali.questionariPredefiniti || Object.keys(impostazioniGenerali.questionariPredefiniti).length === 0" class="notification is-info is-light">
      Nessun template questionario configurato. Aggiungi il primo!
    </div>
    
    <div class="columns">
      <!-- Elenco dei template -->
      <div class="column is-4">
        <aside class="menu">
          <p class="menu-label">Seleziona Template</p>
          <ul class="menu-list">
            <li v-for="(qTemp, key) in impostazioniGenerali.questionariPredefiniti" :key="key">
              <a :class="{'is-active': templateSelezionatoKey === key}" @click="selezionaTemplate(key)">
                {{ qTemp.titolo }}
              </a>
            </li>
          </ul>
        </aside>
        <button class="button is-primary is-fullwidth mt-4" @click="nuovoTemplate">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span>Nuovo Template</span>
        </button>
      </div>

      <!-- Editor del template selezionato -->
      <div class="column is-8" v-if="templateSelezionato">
        <div class="box has-background-white-bis mb-4">
          <div class="is-flex is-justify-content-space-between is-align-items-flex-end is-flex-wrap-wrap" style="gap: 1rem;">
            <div class="field mb-0" style="flex: 1; min-width: 250px;">
              <label class="label">Titolo Questionario</label>
              <div class="control">
                <input class="input is-medium has-text-weight-bold" type="text" v-model="templateSelezionato.titolo">
              </div>
            </div>
            <div>
              <button class="button is-info is-light" @click="duplicaTemplateCorrente" title="Duplica questo template per crearne una copia modificabile">
                <span class="icon"><i class="fas fa-copy"></i></span>
                <span>Duplica Template</span>
              </button>
            </div>
          </div>
        </div>

        <div v-for="(sezione, index) in templateSelezionato.sezioni" :key="sezione.id" class="box mb-5 is-relative" style="border: 2px solid #ddd; background-color: #fafafa;">
          <!-- Toolbar Sezione -->
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-2 pb-2" style="border-bottom: 1px solid #eee;">
            <h3 class="title is-5 mb-0 has-text-grey">
              Sezione {{ index + 1 }}
            </h3>
            <div class="buttons are-small mb-0">
              <button class="button is-light" @click="spostaSezione(index, -1)" :disabled="index === 0" title="Sposta su">
                <span class="icon"><i class="fas fa-arrow-up"></i></span>
              </button>
              <button class="button is-light" @click="spostaSezione(index, 1)" :disabled="index === templateSelezionato.sezioni.length - 1" title="Sposta giù">
                <span class="icon"><i class="fas fa-arrow-down"></i></span>
              </button>
              <button class="button is-danger is-light ml-3" @click="eliminaSezione(index)" title="Elimina sezione">
                <span class="icon"><i class="fas fa-trash"></i></span>
              </button>
            </div>
          </div>
          
          <EditorSezioneQuestionario 
            v-model="templateSelezionato.sezioni[index]" 
            :campiPrecedenti="getCampiPrecedenti(index)" 
          />
        </div>

        <button class="button is-info is-light is-fullwidth mb-5" @click="aggiungiSezione">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span>Aggiungi Sezione</span>
        </button>

        <hr>
        <div class="field is-grouped is-grouped-right">
          <div class="control">
            <button class="button is-info is-light" @click="duplicaTemplateCorrente">
              <span class="icon"><i class="fas fa-copy"></i></span>
              <span>Duplica Template</span>
            </button>
          </div>
          <div class="control" v-if="permettiElimina">
            <button class="button is-danger is-light" @click="eliminaTemplateCorrente">Elimina Template</button>
          </div>
          <div class="control">
            <button class="button is-success" @click="salvaTemplateCorrente">Salva Modifiche</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  </template>
  
<script setup>
  import { ref } from 'vue';
  import { onBeforeRouteLeave } from 'vue-router';
  import EditorSezioneQuestionario from './EditorSezioneQuestionario.vue';
  import { impostazioniGenerali, permettiElimina } from '@/code/utilita';
  import { credenzialiUtente, db } from '../code/firebase';
  import { doc, setDoc, updateDoc } from 'firebase/firestore';

  // LOGICA GESTIONE TEMPLATE QUESTIONARI
  const templateSelezionatoKey = ref(null);
  const templateSelezionato = ref(null);

  const haModificheNonSalvate = () => {
    if (!templateSelezionatoKey.value || !templateSelezionato.value) return false;
    const originale = JSON.stringify(impostazioniGenerali.value.questionariPredefiniti[templateSelezionatoKey.value]);
    const corrente = JSON.stringify(templateSelezionato.value);
    return originale !== corrente;
  };

  const confermaPerditaModifiche = () => {
    if (haModificheNonSalvate()) {
      return confirm("Hai delle modifiche non salvate. Sei sicuro di voler procedere senza salvare?");
    }
    return true;
  };

  const selezionaTemplate = (key) => {
    if (!confermaPerditaModifiche()) return;
    templateSelezionatoKey.value = key;
    const tpl = JSON.parse(JSON.stringify(impostazioniGenerali.value.questionariPredefiniti[key]));
    
    // Auto-migrazione vecchi template
    if (!tpl.sezioni) {
      tpl.sezioni = [
        {
          id: 'sez_' + Date.now(),
          titolo: tpl.titolo || 'Sezione Unica',
          campi: tpl.campi || {},
          condizioneAttivazione: { abilitata: false, campoId: '', opzioneSelezionata: '' },
          ripetibile: { abilitata: false, campoId: '', opzioneSelezionata: '' }
        }
      ];
      if (tpl.file && Object.keys(tpl.file).length > 0) {
        const maxOrder = Object.values(tpl.sezioni[0].campi).reduce((max, c) => Math.max(max, c.ordine ?? 0), -1);
        let offset = 1;
        for (const [fKey, fVal] of Object.entries(tpl.file)) {
          tpl.sezioni[0].campi['campo_' + fKey] = {
            label: fVal.label || fKey,
            tipo: 'file',
            obbligatorio: !!fVal.obbligatorio,
            tipoObbligo: fVal.obbligatorio ? 'assoluto' : 'nessuno',
            url: fVal.url || null,
            txt: fVal.url || '',
            ordine: maxOrder + offset
          };
          offset++;
        }
      }
      delete tpl.campi;
      delete tpl.file;
    } else {
      for (const sez of tpl.sezioni) {
        if (sez.file && Object.keys(sez.file).length > 0) {
          if (!sez.campi) sez.campi = {};
          const maxOrder = Object.values(sez.campi).reduce((max, c) => Math.max(max, c.ordine ?? 0), -1);
          let offset = 1;
          for (const [fKey, fVal] of Object.entries(sez.file)) {
            const newKey = fKey.startsWith('campo_') ? fKey : ('campo_' + fKey);
            if (!sez.campi[newKey]) {
              sez.campi[newKey] = {
                label: fVal.label || fKey,
                tipo: 'file',
                obbligatorio: !!fVal.obbligatorio,
                tipoObbligo: fVal.obbligatorio ? 'assoluto' : 'nessuno',
                url: fVal.url || null,
                txt: fVal.url || '',
                ordine: maxOrder + offset
              };
              offset++;
            }
          }
          delete sez.file;
        }

        if (sez.campi) {
          const list = Object.entries(sez.campi)
            .map(([k, c], idx) => ({ k, c, ord: c.ordine !== undefined ? c.ordine : idx }))
            .sort((a, b) => a.ord - b.ord);
          list.forEach((item, idx) => {
            item.c.ordine = idx;
            if (!item.c.tipoObbligo) {
              item.c.tipoObbligo = item.c.obbligatorio ? 'assoluto' : 'nessuno';
            }
            item.c.obbligatorio = item.c.tipoObbligo !== 'nessuno';
          });
        }
      }
    }

    templateSelezionato.value = tpl;
  };

  const nuovoTemplate = () => {
    if (!confermaPerditaModifiche()) return;
    const chiave = 'template_' + Date.now();
    if (!impostazioniGenerali.value.questionariPredefiniti) {
      impostazioniGenerali.value.questionariPredefiniti = {};
    }
    impostazioniGenerali.value.questionariPredefiniti[chiave] = {
      titolo: 'Nuovo Questionario',
      sezioni: [
        {
          id: 'sez_' + Date.now(),
          titolo: 'Sezione 1',
          campi: {},
          condizioneAttivazione: { abilitata: false, campoId: '', opzioneSelezionata: '' },
          ripetibile: { abilitata: false, campoId: '', opzioneSelezionata: '' }
        }
      ]
    };
    salvaSuFirestore();
    selezionaTemplate(chiave);
  };

  const salvaTemplateCorrente = () => {
    if (!templateSelezionatoKey.value || !templateSelezionato.value) return;
    if (templateSelezionato.value.sezioni) {
      for (const sez of templateSelezionato.value.sezioni) {
        if (sez.campi) {
          const list = Object.entries(sez.campi)
            .map(([k, c], idx) => ({ k, c, ord: c.ordine !== undefined ? c.ordine : idx }))
            .sort((a, b) => a.ord - b.ord);
          list.forEach((item, idx) => {
            item.c.ordine = idx;
            if (!item.c.tipoObbligo) {
              item.c.tipoObbligo = item.c.obbligatorio ? 'assoluto' : 'nessuno';
            }
            item.c.obbligatorio = item.c.tipoObbligo !== 'nessuno';
          });
        }
        delete sez.file;
      }
    }
    impostazioniGenerali.value.questionariPredefiniti[templateSelezionatoKey.value] = JSON.parse(JSON.stringify(templateSelezionato.value));
    salvaSuFirestore();
  };

  const duplicaTemplateCorrente = () => {
    if (!templateSelezionatoKey.value || !templateSelezionato.value) return;
    if (!confermaPerditaModifiche()) return;

    const chiave = 'template_' + Date.now();
    const clone = JSON.parse(JSON.stringify(templateSelezionato.value));
    
    // Assegna nuovo titolo
    clone.titolo = (clone.titolo || 'Nuovo Questionario') + ' (Copia)';
    
    // Rigenera ID univoci per le sezioni per evitare collisioni
    if (clone.sezioni && Array.isArray(clone.sezioni)) {
      clone.sezioni.forEach((sez, sIdx) => {
        sez.id = 'sez_' + (Date.now() + sIdx);
      });
    }

    if (!impostazioniGenerali.value.questionariPredefiniti) {
      impostazioniGenerali.value.questionariPredefiniti = {};
    }
    impostazioniGenerali.value.questionariPredefiniti[chiave] = clone;

    salvaSuFirestore();
    selezionaTemplate(chiave);
  };

  const eliminaTemplateCorrente = () => {
    if (!templateSelezionatoKey.value) return;
    if (confirm("Sei sicuro di voler eliminare questo template?")) {
      delete impostazioniGenerali.value.questionariPredefiniti[templateSelezionatoKey.value];
      salvaSuFirestore();
      templateSelezionatoKey.value = null;
      templateSelezionato.value = null;
    }
  };

  const getCampiPrecedenti = (currentIndex) => {
    if (!templateSelezionato.value || !templateSelezionato.value.sezioni) return [];
    const list = [];
    for (let i = 0; i < currentIndex; i++) {
      const sez = templateSelezionato.value.sezioni[i];
      if (sez.campi) {
        for (const [key, campo] of Object.entries(sez.campi)) {
          if (campo.tipo === 'checkbox_multiplo' || campo.tipo === 'accettazione') {
            list.push({ 
              id: key, 
              label: campo.label || key, 
              tipo: campo.tipo, 
              opzioniStr: campo.opzioniStr || '' 
            });
          }
        }
      }
    }
    return list;
  };

  const aggiungiSezione = () => {
    if (!templateSelezionato.value) return;
    if (!templateSelezionato.value.sezioni) templateSelezionato.value.sezioni = [];
    templateSelezionato.value.sezioni.push({
      id: 'sez_' + Date.now(),
      titolo: 'Nuova Sezione',
      campi: {},
      condizioneAttivazione: { abilitata: false, campoId: '', opzioneSelezionata: '' },
      ripetibile: { abilitata: false, campoId: '', opzioneSelezionata: '' }
    });
  };

  const spostaSezione = (index, delta) => {
    if (!templateSelezionato.value) return;
    const newIdx = index + delta;
    if (newIdx < 0 || newIdx >= templateSelezionato.value.sezioni.length) return;
    
    const arr = templateSelezionato.value.sezioni;
    const temp = arr[index];
    arr[index] = arr[newIdx];
    arr[newIdx] = temp;
  };

  const eliminaSezione = (index) => {
    if (!templateSelezionato.value) return;
    if (confirm("Vuoi davvero eliminare questa sezione?")) {
      templateSelezionato.value.sezioni.splice(index, 1);
    }
  };

  onBeforeRouteLeave((to, from, next) => {
    if (haModificheNonSalvate()) {
      const conferma = confirm("Hai delle modifiche non salvate al template. Sei sicuro di voler abbandonare la pagina?");
      if (!conferma) {
        next(false);
        return;
      }
    }
    next();
  });

  const salvaSuFirestore = async () => {
    try {
      const docRef = doc(db, 'utilita', 'impostazioni');
      try {
        await updateDoc(docRef, {
          questionariPredefiniti: impostazioniGenerali.value.questionariPredefiniti || {}
        });
      } catch (e) {
        // Fallback if document doesn't exist
        await setDoc(docRef, {
          questionariPredefiniti: impostazioniGenerali.value.questionariPredefiniti || {}
        }, { merge: true });
      }
      console.log('[PaginaSviluppo] Template salvati con successo su Firestore');
      alert('Modifiche salvate con successo!');
    } catch (error) {
      console.error('Errore nel salvataggio dei template:', error);
      alert('Errore nel salvataggio dei template su Firestore');
    }
  };

</script>
